'use strict';

module.exports = {
  hits: require('./hits.js'),
  popularIn: require('./popularIn.js')
};



//////////////////
// WEBPACK FOOTER
// /builds/BootPM/classic.yarnpkg.cn/node_modules/autocomplete.js/src/sources/index.js
// module id = ../../node_modules/autocomplete.js/src/sources/index.js
// module chunks = 6